<template>
    <div class="content-wrap"
         :class="{ 'no-scroll' : ! listScrollable }"
         v-hammer:swipe.horizontal="changeCategory"
    >
        <kapp-header id="mainHeader" :show-header="listScrollable"></kapp-header>
        <transition :name="animDirection">
            <transition-group :name="hideArticleEffect" tag="div" class="list list--article" :key="categoryFilter">
                <kapp-articleBlock v-for="article in filteredArticles" :available_categories="categories"
                                   :article="article"
                                   v-bind:key="'uid-' + article.uid"
                                   :uid="article.uid"
                                   :class="{ 'is-invisible' : article.fullView }" />
            </transition-group>
        </transition>
    </div>
</template>


<script>
    import KappCategoryNav from "../components/subparts/KappCategoryNav";
    import KappNews from "../components/blocks/KappNews";

    import debounce from 'lodash.debounce';

    import api, { ApiDefaults } from '../utils/api_call';
    import Header from "../components/layouts/Header";

    export default {
        name: "KappAktuelles",
        components: {
            'kapp-categories': KappCategoryNav,
            'kapp-articleBlock': KappNews,
            'kapp-header': Header
        },
        data() {
            return {
                articles: this.$store.getters.newsItems,
                pageTitle: 'Aktuelles',
                categories: this.$store.getters.newsCategories,
                fullTextFilter: '',
                categoryFilter: '',
                listScrollable: true,
                categoriesVisible: true,
                animDirection: 'slide-left',
                hideArticleEffect: null
            };
        },

        methods: {
            track() {
                this.$ga.page('/aktuelles');
            },
            fetchData: debounce(function () {

                let apiParams = Object.assign({}, ApiDefaults, {method: 'get', params: {id: 2}});
                api(apiParams)
                    .then(( response ) => {
                        if ( response.status === 200 ) {

                            this.articles = response.data.news.content.map(( item ) => {

                                                        item.categories = [ parseInt(item.categories) ];
                                                        item.visible = true;

                                                        return item;
                                                    })
                                                    .sort(( a, b ) => {
                                                        return b.datetime - a.datetime;
                                                    });

                            this.categories = Object.values(response.data.news.categories);
                            Events.$emit('showCategories', this.categories);
                        }
                    })
                    .catch(( err ) => {
                        console.warn(err.message);
                    })
                    .finally(() => this.hideArticleEffect = 'hideArticles');


            }, 125),

            lightbox: function ( evt ) {

                this.listScrollable = !evt.state;
                this.categoriesVisible = !evt.state;
            //     if ( evt.state ) {
            //         this.$el.querySelector('.list--article').style.height = this.$el.scrollHeight + 'px';
            //         // this.articles = this.articles.map(( item ) => {
            //         //     item.visible = (item.uid === evt.uid);
            //         //     return item;
            //         // });
            //         // _.map(this.articles, ( item ) => item.visible = (item.uid === evt.uid));
            //     }
            //     else {
            //         // this.fetchData();
            //         this.$el.querySelector('.list--article').style.height = '';
            //         // this.articles = this.articles.map(( item ) => {
            //         //     item.visible = true;
            //         //     return item;
            //         // });
            //         // _.map(this.articles, ( item ) => item.visible = true);
            //     }
            //
            //
            },
            switchCategory: function ( val ) {

                if ( val === '' ) {
                    this.animDirection = 'news-right';
                    val = 0;
                }
                else {
                    val = val.toString().split('-')[ 1 ];

                    if ( val < this.categoryFilter )
                        this.animDirection = 'news-right';

                    else
                        this.animDirection = 'news-left';
                }

                this.$nextTick(() => this.categoryFilter = parseInt(val));
            },
            changeCategory: function ( evt ) {
                // ignore header component
                if ( evt.target.classList.contains('header') ) return;

                let idx = this.categories.findIndex(function ( cat ) {
                    return cat.uid === this.categoryFilter;
                }.bind(this));

                if ( evt.type !== 'swipeleft' ) { // go left
                    if ( typeof this.categories[ idx - 1 ] !== 'undefined' ) {
                        Events.$emit('category:goto', 'cat-' + this.categories[ idx - 1 ].uid);
                        return;
                    }
                    else {
                        Events.$emit('category:goto', '');
                    }
                }
                else { // go right
                    if ( typeof this.categories[ idx + 1 ] !== 'undefined' ) {
                        Events.$emit('category:goto', 'cat-' + this.categories[ idx + 1 ].uid);
                        return;
                    }
                }
            }

        },
        computed: {
            filteredArticles: function () {
                let filter = this.fullTextFilter,
                    category = this.categoryFilter;

                return this.articles.filter(function ( art ) {
                    let textFound = true,
                        inCategory = true;

                    /** Text Search */
                    if ( this.filter ) textFound = art.title.toLowerCase().includes(this.filter);

                    /** Category search */


                    if ( this.category !== 0 && this.category !== '' ) {
                        inCategory = (art.categories.indexOf(this.category) !== -1);
                    }

                    return textFound && inCategory;

                }, {filter: filter, category: category});
            }
        },
        created() {
            // this.fetchData();
            Events.$on('switchContentCategory', this.switchCategory);
            Events.$on('lightbox', this.lightbox);
        },
        mounted() {
            // this.fetchData();
            Events.$emit('showCategories', this.categories);
        }
    };
</script>

<style scoped>
    .news-right-enter-active,
    .news-right-leave-active,
    .news-left-enter-active,
    .news-left-leave-active {
        position: absolute;
        top: 145px;
        left: 30px;
        right: 30px;
        width: auto;
    }

    .news-right-enter-active {
        /*left: 60px;*/
        animation: slide-right .4s ease-in-out forwards;
    }

    .news-right-leave-active {
        animation: slide-left .4s ease-in-out reverse forwards;
    }

    .news-left-enter-active {
        animation: slide-left .4s ease-in-out forwards;
    }

    .news-left-leave-active {
        animation: slide-right .4s ease-in-out reverse forwards;
    }

    .content-wrap.no-scroll .list .article {
        opacity: 0;
    }
    .content-wrap.no-scroll .list .article.article--single {
        opacity: 1;
    }
</style>



// WEBPACK FOOTER //
// src/pages/KappAktuelles.vue